import React, { useState } from 'react';
import { useReactFlow } from '@xyflow/react';
import AutomationService from '../../../services/automationService';

const Topbar = ({ workflow, onSave }) => {
    const { toObject } = useReactFlow();
    const [name, setName] = useState(workflow?.name || 'New Workflow');
    const [isSaving, setIsSaving] = useState(false);

    const handleSave = async () => {
        setIsSaving(true);
        try {
            const flow = toObject();
            await onSave(name, flow);
        } catch (error) {
            console.error('Failed to save:', error);
            alert('Failed to save workflow');
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="automation-topbar" style={{
            height: '60px',
            borderBottom: '1px solid #ddd',
            display: 'flex',
            alignItems: 'center',
            padding: '0 20px',
            justifyContent: 'space-between',
            backgroundColor: '#fff'
        }}>
            <div className="topbar-left">
                <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    style={{
                        fontSize: '18px',
                        fontWeight: 'bold',
                        border: '1px solid transparent',
                        padding: '5px',
                        borderRadius: '4px'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#ddd'}
                    onBlur={(e) => e.target.style.borderColor = 'transparent'}
                />
            </div>
            <div className="topbar-right" style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                <div className="trigger-selector">
                    <label style={{ marginRight: '8px', fontSize: '14px', color: '#666' }}>Trigger:</label>
                    <select
                        value={workflow?.trigger_type || 'manual'}
                        onChange={(e) => onSave(name, toObject(), e.target.value)}
                        style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ddd' }}
                    >
                        <option value="manual">Manual Execution</option>
                        <option value="on_registration">On Registration</option>
                        <option value="on_lead_captured">On Lead Captured</option>
                    </select>
                </div>
                <button
                    onClick={handleSave}
                    disabled={isSaving}
                    style={{
                        backgroundColor: '#007bff',
                        color: '#fff',
                        border: 'none',
                        padding: '8px 20px',
                        borderRadius: '4px',
                        cursor: isSaving ? 'not-allowed' : 'pointer',
                        opacity: isSaving ? 0.7 : 1
                    }}
                >
                    {isSaving ? 'Saving...' : 'Save Workflow'}
                </button>
            </div>
        </div>
    );
};

export default Topbar;
